module.exports = __webpack_public_path__ + "media/images/iconBell__okGreen-3121b49ae9035b1ecfa62c61957c9828.png";